import { apiClient } from './apiClient';

/**
 * Vector search service for AI-powered semantic search
 */
export class VectorService {
  constructor() {
    this.BASE_URL = '/vector';
  }

  /**
   * Perform vector search on claims
   * @param {Object} params - Search parameters
   * @param {string} params.query - Natural language search query
   * @param {string} params.collectionName - Collection to search in (e.g., 'claims')
   * @param {number} params.topK - Number of results to return (default: 10)
   * @param {Object} params.filters - Metadata filters to apply
   * @returns {Promise<Object>} Search results with documents
   */
  async searchClaims(query, collectionName = 'claims', topK = 10, filters = {}) {
    try {
      const response = await apiClient.post(`${this.BASE_URL}/search`, {
        query,
        collectionName,
        topK,
        filters
      });
      return response;
    } catch (error) {
      console.error("Error performing vector search. See network tab for details or server logs.");
      throw error;
    }
  }

  /**
   * Perform vector search with pagination support
   * @param {Object} params - Search parameters
   * @param {string} params.query - Natural language search query
   * @param {string} params.collectionName - Collection to search in
   * @param {number} params.topK - Number of results (default: 10)
   * @param {number} params.page - Page number for pagination
   * @param {number} params.limit - Results per page
   * @param {Object} params.filters - Metadata filters
   * @returns {Promise<Object>} Paginated search results
   */
  async searchClaimsWithPagination(params = {}) {
    try {
      const {
        query,
        collectionName = 'claims',
        topK = 10,
        page = 1,
        limit = 10,
        filters = {}
      } = params;

      const response = await apiClient.post(`${this.BASE_URL}/search`, {
        query,
        collectionName,
        topK,
        page,
        limit,
        filters
      });
      return response;
    } catch (error) {
      console.error("Error performing vector search with pagination.", error);
      throw error;
    }
  }
}

// Create a singleton instance
export const vectorService = new VectorService();